import {
  APIFactory,
  factory
} from './../api';

const ModuleName = 'RessieApp';

export class BundleAPI extends APIFactory {

  /* @ngInject */
  constructor(...args) {
    super(...args);
    this.actions = {
      'contacts': {
        'method': 'GET',
        'url': `${this.api.getDomain()}/contacts/:type`
      },
      'packages': {
        'method': 'GET',
        'url': `${this.api.getDomain()}/packages`,
        'isArray': true
      },
      'packages': {
        'method': 'GET',
        'url': `${this.api.getDomain()}/packages`,
        'isArray': true
      },
      'products': {
        'method': 'GET',
        'url': `${this.api.getDomain()}/products`,
        'params': { nested: true },
      },

      'view': {
        'method': 'GET',
        'url': `${this.api.getDomain()}/bundle/:id`,
        'transformResponse':  function (response) {
          const data = JSON.parse(response);
          if (data.error !== undefined) throw new Error(data.error);
          function toUTC(input) {
            let date = new Date(input);
            return new Date([date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate()]);
          }
          for (const name in data.rules) {
            if (data.rules.hasOwnProperty(name)) {
              const rule = data.rules[name];
              if (rule.active) {
                if (rule.date) rule.date = toUTC(rule.date)
                if (rule.start_date) rule.start_date = toUTC(rule.start_date);
                if (rule.end_date) rule.end_date = toUTC(rule.end_date);
              }
            }
          }
          return data;
        }
      },
      'list': {
        'method': 'GET',
        'url': `${this.api.getDomain()}/bundles`,
        'isArray': true
      },
      'save': {
        'method': 'POST',
        'url': `${this.api.getDomain()}/bundle`,
        'interceptor': {
          response: function (response) {
            const data = response.data;
            if (data.error !== undefined) throw new Error(data.error)
            return response;
          }
        }
      },
      'update': {
        'method': 'PUT',
        'url': `${this.api.getDomain()}/bundle/:id`,
        // 'params': {
        //   id: '@_id'
        // },
        'interceptor': {
          response: function (response) {
            const data = response.data;
            if (data.error !== undefined) throw new Error(data.error)
            return response;
          }
        }
      }
    };
  }

  get url() {
    return `${this.api.getDomain()}/bundle/:id`;
  }

  setAction(name, obj) {
    this.actions[name] = obj;
  }

};

export const API = (MODULE) => {
  return factory(MODULE, 'BundleAPI', BundleAPI);
}

export default () => {
  return API(ModuleName);
};



// WEBPACK FOOTER //
// ./client/assets/scripts/modules/bundles/api.js